import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type FacebookPage from "./FacebookPage";

@Model()
class FacebookPost extends ApplicationRecord {
  static jsonapiType = "facebook_posts";

  @Attr() articleId: number;

  @Attr() author: string;

  @Attr() body: string;

  @Attr({ persist: false }) createdAt: string;

  @BelongsTo() facebookPage: FacebookPage;

  @Attr() facebookPageId: number;

  @Attr() language: string;

  @Attr() postId: number;

  @Attr() postLinks: string;

  @Attr() publishedAt: string;

  @Attr() url: string;
}

export default FacebookPost;
